module.exports = __webpack_public_path__ + "static/media/yoga-img.ceebd70d.jpg";